import { render, staticRenderFns } from "./_ProductsDatabaseTable.vue?vue&type=template&id=278bdafa"
import script from "./_ProductsDatabaseTable.vue?vue&type=script&lang=js"
export * from "./_ProductsDatabaseTable.vue?vue&type=script&lang=js"
import style0 from "./_ProductsDatabaseTable.vue?vue&type=style&index=0&id=278bdafa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports